import axios from "axios";

export const getDeviceTaskAPI = async task_id => {
  let response = await axios({
    url: `/api/v2/device/task`,
    method: "GET",
    params: {
      task_id: task_id
    }
  });
  const task_status = response.data.task.status;
  return task_status;
};
